import { Box, type BoxProps, type MantineRadius } from "@mantine/core"
import type { PropsWithChildren } from "react"

import classes from "./PaperGhost.module.css"

export function PaperGhost({ children, ...props }: PropsWithChildren<BoxProps> & { radius?: MantineRadius }) {
  return (
    <Box className={classes.ghost} {...props} pos="relative">
      {children}
    </Box>
  )
}
